export enum CanCreateRequestStatusEnum {
  Unknown = 0,
  Success = 1,
  RequestExist = 2,
  MaximumRequestCount = 3,
}
